import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import React, { useEffect, useRef } from "react";
import OwlCarousel from "react-owl-carousel3";
import { Link } from "react-router-dom";
import ChooseUs from "../../assets/images/os-2.webp";
import Joinus from "../../common/Joinus";
import whychoose from "../../assets/images/why chose us.webp"
// import gif from "../../assets/images/homegif.gif"
import gif from "../../assets/images/gif_final.gif"
import {
  caseStudy,
  ourClients,
  technologyPartner,
  whychoose2
} from "./Constant";
import { Helmet } from 'react-helmet';
import ServiceSection2 from "./ServiceSection2";
const HomeBanner = () => {
  const scrollToTop = () => {
    window.scrollTo(0, 0);
  };
  const dotRefs = useRef([]);
  const newdotRefs = useRef([])
  console.log(dotRefs, "dotRefs_loh")
  const colors = ["#ffc250", "#e9536c", "#f4b1b8", "#1eacc0"];
  const section1Ref = useRef(null);


  useEffect(() => {
    const el = document.getElementById("carouselExampleDark");
    if (el && window.bootstrap) {
      const carousel = new window.bootstrap.Carousel(el, {
        interval: 3000,
        ride: 'carousel',
        touch: true,
        pause: false
      });

      setTimeout(() => {
        carousel.cycle();
      }, 500);
    }
  }, []);


  useEffect(() => {
    const handleScroll = () => {
      const currentY = window.scrollY;
      console.log(`Scr ${currentY.toFixed(0)}px`);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Helmet>
        <title>Best Digital Marketing Services in India | SMS ZOO ZOO</title>
        <meta
          name="description"
          content="Increase visibility, leads, and conversions with performance-driven digital marketing services in India. Grow your business with SMS ZOO ZOO today."
        />
        <meta
          name="keywords"
          content="Digital Marketing Services ,Digital marketing agency in Chennai, Best Digital Marketing Agency,Lead generation Chennai,digital marketing company in india, digital marketing firms in india,digital marketing company in india
   digital marketing agency in chennai,digital marketing services,online marketing agency,digital marketing marketing,
   best digital marketing agency, best digital marketing companies, digital marketing agency website,
       marketing agency near me,
        top digital marketing companies,
        digital marketing near me,
        digital marketing agency near me,
        digital marketing services near me,
        top marketing agency in chennai ,
        digital marketing and advertising agency in chennai ,
       seo digital marketing in chennai ,
        search engine optimization marketing ,
       seo company in chennai ,
        seo agencies in chennai,
       best digital marketing company in india ,
        best digital marketing agency in india ,
        best seo agency in chennai,
        best seo services in chennai,
        top digital marketing agency in chennai ,
        seo experts in chennai
        online marketing services Chennai,
        online marketing services India,
        online business promotion Chennai,
        online business promotion India"
        />
      </Helmet>
      <div className="home-banner " ref={section1Ref}>
        <div className="banner-wrapper position-relative overflow-hidden">
          <div className="pt-5">
            <div className="banner-bg-round">
              {colors.map((color, i) => (
                <div
                  data-aos={`fade-${i === 0 ? "down" : i === 1 ? "right" : i === 2 ? "up" : i === 3 ? "down" : ""}`} data-aos-delay="1000"
                  key={i}
                  style={{
                    position: "absolute",
                    border: `${i == 0 ? "9px solid white" : "none"}`,
                    backgroundColor: color,
                    borderRadius: "50%",
                  }}
                  className={`dot_color_${i + 1}`}
                />
              ))}
            </div>
          </div>
          <div className="container-fluid pt-5 mt-5">
            <div
              id="carouselExampleDark"
              class="carousel carousel-dark slide"
              data-bs-ride="carousel"
              data-bs-interval="3000"
              data-bs-touch="true"
              data-bs-pause="false"
            >
              <div className="carousel-inner" data-aos="fade-down" data-aos-delay="300">
                <div className="banner-22"></div>
                <div className="carousel-item active" data-bs-interval="3000">
                  <div className="d-block height-carousel-banner w-100" />
                  <div className="carousel-caption  d-md-block">
                    {/* <div className="banner-bg-round"></div> */}
                    <div className="pos-z-index">
                      <div className="row justify-content-center">
                        <div className="col-lg-12">
                          <div className="">
                            <h2 className="yellow-sub-heading text-center mb-3">
                              DIGITAL MARKETING
                            </h2>
                            <h2 className="black-sub-heading text-center">
                              "Digital Solutions for a Digital World"
                            </h2>
                            <h3 className="banner-heading text-center pt-4 pb-5">
                              “Unlock Your Online Potential
                              <br className="br-tag" /> Boost Your Brand
                              Visibility
                              <br className="br-tag" />
                              Transform Your Marketing Strategy”
                            </h3>
                            <Link
                              to="/contact_us"
                              className="d-flex justify-content-center contactresponsive"
                              onClick={scrollToTop}
                            >
                              <button
                                type="button"
                                className="btn get-in-btn d-flex align-items-center gap-2"
                              >
                                Contact us
                                <i class="fa-solid fa-arrow-right-long"></i>
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="carousel-item">
                  <div className="d-block height-carousel-banner w-100" />
                  <div className="carousel-caption d-md-block">
                    <div className="pos-z-index">
                      <div className="row justify-content-center">
                        <div className="col-lg-12">
                          <div className="">
                            <h2
                              className="yellow-sub-heading text-center mb-3"
                            >
                              WhatsApp Services
                            </h2>
                            <h2 className="black-sub-heading text-center">
                              "Messaging that Means Business"
                            </h2>
                            <h3 className="banner-heading text-center pt-4 pb-5">
                              “Connect Instantly, Sell More
                              <br className="br-tag" /> Convert on WhatsApp with
                              <br className="br-tag" /> Your Brand Name”
                            </h3>
                            <Link
                              to="/contact_us"
                              className="d-flex justify-content-center contactresponsive"
                              onClick={scrollToTop}
                            >
                              <button
                                type="button"
                                className="btn get-in-btn d-flex align-items-center gap-2"
                              >
                                Contact us
                                <i class="fa-solid fa-arrow-right-long"></i>
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-item">
                  <div className="d-block height-carousel-banner w-100" />
                  <div className="carousel-caption d-md-block">
                    {/* <div className=""></div> */}
                    <div className="pos-z-index">
                      <div className="row justify-content-center">
                        <div className="col-lg-12">
                          <div className="">
                            <h5
                              className="yellow-sub-heading text-center mb-3"
                            // style={{ color: "#1EACC0" }}
                            >
                              Social Media Marketing
                            </h5>
                            <h2 className="black-sub-heading text-center">
                              "Make Your Brand Insta-Famous"
                            </h2>
                            <h3 className="banner-heading banner-heading3 text-center pt-4 pb-5">
                              “Right Message, Right Audience
                              <br className="br-tag" />At the Right Time
                              <br className="br-tag" />That’s Social Media, Done Right”
                            </h3>
                            <Link
                              to="/contact_us"
                              className="d-flex justify-content-center contactresponsive"
                              onClick={scrollToTop}
                            >
                              <button
                                type="button"
                                className="btn get-in-btn d-flex align-items-center gap-2"
                              >
                                Contact us
                                <i class="fa-solid fa-arrow-right-long"></i>
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="carousel-item" data-bs-interval="2000">
                  <div className="d-block height-carousel-banner w-100" />
                  <div className="carousel-caption  d-md-block">
                    {/* <div className="banner-bg-round"></div> */}
                    <div className="pos-z-index">
                      <div className="row justify-content-center">
                        <div className="col-lg-12">
                          <div className="">
                            <h2
                              className="yellow-sub-heading text-center mb-3"
                            // style={{ color: "#e9536c" }}
                            >
                              SMS Services
                            </h2>
                            <h2 className="black-sub-heading text-center">
                              "Text Your Way to Success"
                            </h2>
                            <h3 className="banner-heading text-center pt-4 pb-5">
                              “Instant and Guaranteed <br className="br-tag" />{" "}
                              Message Delivery,
                              <br className="br-tag" /> All within Blink of an
                              Eye”
                            </h3>
                            <Link
                              to="/contact_us"
                              className="d-flex justify-content-center contactresponsive"
                              onClick={scrollToTop}
                            >
                              <button
                                type="button"
                                className="btn get-in-btn d-flex align-items-center gap-2"
                              >
                                Contact us
                                <i class="fa-solid fa-arrow-right-long"></i>
                              </button>
                            </Link>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <button
                class="carousel-control-prev d-none d-md-block"
                type="button"
                data-bs-target="#carouselExampleDark"
                data-bs-slide="prev"
              >
                <span
                  class="carousel-control-prev-icon"
                  aria-hidden="true"
                ></span>
                <span className="visually-hidden">Previous</span>
              </button>
              <button
                class="carousel-control-next d-none d-md-block"
                type="button"
                data-bs-target="#carouselExampleDark"
                data-bs-slide="next"
              >
                <span
                  className="carousel-control-next-icon"
                  aria-hidden="true"
                ></span>
                <span class="visually-hidden">Next</span>
              </button>
            </div>
          </div>
        </div>

        <div className="pos-z-index ">
          <div className="row justify-content-center">
            <div className="col-lg-10">
              <div className="">
                <h1 className="our-clients-heading"><br></br>
                  Result-Driven Digital Marketing Services in India for Growing Businesses
                </h1>
              </div>
            </div>
          </div>
        </div>

        <div className="pos-z-index ">
          <div className="row justify-content-center"
            data-aos="fade-down" data-aos-delay="300"
          >
            <div className="col-lg-10">
              <div className="">
                <div className="sms-sub-heading">
                  We provide complete digital marketing services in India designed to help businesses build visibility, 
                  generate quality leads, and drive consistent growth in today’s competitive online landscape. Our expert 
                  team delivers end-to-end solutions, including digital marketing strategy, social media marketing, 
                  SMS marketing, and WhatsApp marketing, helping brands connect with their target audience across multiple 
                  platforms. Whether you’re a startup or an established enterprise, our data-driven approach ensures 
                  measurable results and scalable success across India’s diverse and fast-growing digital market.
                  </div>
              </div>
            </div>
          </div>
        </div>

        <div style={{ position: "relative" }}>

          <div className="home-content"
          // ref={section1Ref}
          >
            <div className="our-clients mb-0 ">
              <div className="container">
                <div className="pb-4">
                  <h5 className="our-clients-heading">Our Valuable Clients</h5>
                </div>
                <div className="row justify-content-center py-3">
                  {ourClients.map((item, index) => {
                    return (
                      <div className="col-lg-2 col-md-2 col-4 mb-3" key={index}
                        data-aos={`fade-${index % 2 === 0 ? "down" : "up"}`} data-aos-delay="300"
                      >
                        <div className="our-clients-img-contain">
                          <img className="our-clients-img" src={item?.img} alt={`logo${index}`} />
                        </div>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            {/* <div className="gif-sections pb-5" id="color_change">
              <div className="container">
                <div className="position-relative" id="new_dot_container">
                  <DotLottieReact
                    // src="https://lottie.host/7506ea27-3875-44b2-a1d8-fc1f39a35eda/vN80b5mWmS.lottie"
                     src="https://lottie.host/2bcee023-ea3a-4b0e-b233-60732f2c79a2/b4ONmJsl2P.lottie"
                    loop
                    autoplay
                  />
               
              


                  {colors.map((color, i) => (
                    <div
                      key={i}
                      ref={(el) => (newdotRefs.current[i] = el)}
                      id={`dot_con_${i}`}
                      style={{
                        position: "absolute",
                        border: `${i == 0 ? "9px solid white" : "none"}`,
                        top: `48%`,
                        left: `49%`,
                        width: `40px`,
                        height: `40px`,
                        opacity: 0,
                        backgroundColor: color,
                        borderRadius: "50%",
                        zIndex: 1000,
                        pointerEvents: "none",
                        willChange: "top, left, width, height, opacity, margin-left",
                      }}
                    />
                  ))}
                </div>
              </div>
            </div> */}
            <div className="gifpadding">
              <img alt="Moving ball" src={gif} className="homegif" />
            </div>
            <div className="why-choose-us"
            //  ref={section2Ref}
            >
              <div className="container">
                <div className="row">
                  <div className="col-lg-6 col-md-5">
                    <h2 className="why-choose-heading mb-lg-0 mb-md-0 mb-4 "
                      data-aos="fade-up" data-aos-delay="300"
                    >
                      Why <br /> Choose Us
                    </h2>
                  </div>
                  <div className="col-lg-6 col-md-7 my-auto">
                    <div className="row">
                      <div className="col-lg-5 col-md-6 col-6 border-end border-dark"
                        data-aos="fade-down" data-aos-delay="300"
                      >
                        <h4 className="service-heading text-center">09</h4>
                        <p className="text-center mb-0">Year of experiences</p>
                      </div>
                      <div className="col-lg-5 col-md-6 col-6"
                        data-aos="fade-up" data-aos-delay="300"
                      >
                        <h5 className="service-heading text-center">250+</h5>
                        <p className="text-center mb-0">Happy Clients</p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="mb-5">
                  {/* <WhyChoose className="dot-slot" id="target_0" />s */}
                  <div className="row">
                    <div className="col-lg-5 d-flex align-items-center justify-content-center">
                      <img alt="why choose us" src={whychoose} className="w-100"
                        data-aos="fade-down" data-aos-delay="300"
                      />
                    </div>
                    <div className="col-lg-7">
                      <div className="row">
                        {whychoose2.map((item, index) => {
                          return (
                            <div className="col-lg-6 col-md-6" key={index}
                              data-aos={`fade-${index % 2 === 1 ? "down" : "up"}`} data-aos-delay="300"
                            >
                              <div className="half_circle_card">
                                <div className={`${index % 2 === 0 ? "mt_odd" : "mt_even"}`}>
                                  <div className="position-relative d-flex justify-content-center">
                                    <div className="half_circle"></div>
                                    <p className="percentage">%</p>
                                  </div>
                                  <h2 className="why_choose_heading">{item.title}</h2>
                                  <p className="choose text-center">{item.content}</p>
                                </div>
                              </div>
                            </div>
                          )
                        })}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="our-clients">
              <div className="container">
                <div className="pb-4">
                  <h5 className="our-clients-heading">Technology Partners </h5>
                </div>
                <div className="row justify-content-center">
                  <div className="col-lg-10 col-md-10">
                    <div className="row justify-content-center py-3">
                      {technologyPartner.map((item, index) => {
                        return (
                          <div className="col-lg-3 col-md-3 col-4 mb-3" key={index}
                            data-aos={`fade-${index % 2 === 1 ? "up" : "down"}`} data-aos-delay="300"

                          >
                            <div className="our-clients-img-contain ">
                              <img
                                className="our-clients-img"
                                src={item?.img}
                                alt="Client logo"
                              />
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="our-services">
              <div className="container">
                <h2 className="customer-says-heading text-center mb-5"
                  data-aos="fade-down" data-aos-delay="300"
                >
                  Our Services
                </h2>
                {/* <ServicesSection /> */}
                <ServiceSection2 />
              </div>
            </div>
            <div className="our-customer-says mb-5">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-lg-4 col-md-5">
                    <div className="padding-left-50">
                      <img
                        className="quote-grey"
                        src={require("../../assets/images/quote-black1.webp")}
                        alt="Quote"
                      />
                      <h2 className="customer-says-heading"
                        data-aos="fade-down" data-aos-delay="300"
                      >
                        Our <br /> Customers Say!
                      </h2>
                    </div>
                  </div>
                  <div className="col-lg-8 col-md-7">
                    <div>
                      <OwlCarousel
                        className="owl-theme"
                        loop
                        autoplay={true}
                        items="1"
                        dots={false}
                        smartSpeed={2000}
                        nav={true}
                        navText={[
                          `<i class="fa fa-chevron-left"></i>`,
                          `<i class="fa fa-chevron-right"></i>`,
                        ]}
                        margin={20}
                        // center={true}
                        autoplayTimeout={5000}
                        responsive={{
                          360: {
                            items: "1",
                          },
                          414: {
                            items: "1",
                          },
                          670: {
                            items: "1",
                          },
                          992: {
                            items: "1",
                          },

                          1200: {
                            items: "1.3",
                          },
                        }}
                      >
                        {caseStudy.map((item, index) => {
                          return (
                            <div className="case-study-card" key={index}>
                              <div>
                                <h5 className="casestudy-name">{item.title}</h5>
                                <p className="casestudy-para mb-3">{item.para}</p>
                                <h5 className="casestudy-name">{item.name}</h5>
                                <h5 className="casestudy-name">{item?.company}</h5>

                              </div>
                              <img
                                className="casestudy-img mb-4"
                                src={require("../../assets/images/quote-grey.webp")}
                                alt="Quote"
                              ></img>
                            </div>
                          );
                        })}
                      </OwlCarousel>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <Joinus />
        </div>
      </div >
    </>
  );
};

export default HomeBanner;